var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.52649C7.42349 5.10306 4.65212 3.96017 3.16165 4.80124C1.61279 5.67525 1.61278 11.3248 3.16165 12.1988C4.65212 13.0398 7.42349 11.8969 9 11.4735",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.52649C16.5765 5.10306 19.3479 3.96017 20.8384 4.80124C22.3872 5.67525 22.3872 11.3248 20.8384 12.1988C19.3479 13.0398 16.5765 11.8969 15 11.4735",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5C14.2091 12.5 16 10.7091 16 8.5C16 6.29086 14.2091 4.5 12 4.5C9.79086 4.5 8 6.29086 8 8.5C8 10.7091 9.79086 12.5 12 12.5Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77244 11.5L8.34515 17.8753C8.01375 19.3555 7.84805 20.0957 8.18452 20.3368C9.33435 21.1607 10.7588 18.5976 12 18.5976C13.13 18.5976 14.817 21.0523 15.8155 20.3368C16.1519 20.0957 15.9862 19.3555 15.6548 17.8753L14.2276 11.5",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate02);
export default __webpack_public_path__ + "static/media/certificate-02.4a407d80d6fa831716f39461150750c0.svg";
export { ForwardRef as ReactComponent };